<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novega uporabnika:
    </h2>

    <UserForm
      @save="save"
      @cancel="cancel"
      :userTypes="userTypes"
      ref="form"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserForm from '@/components/UserForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    UserForm
  },
  mixins: [
    asyncDataStatus
  ],
  computed: {
    ...mapGetters('auth', ['childCompanyUserIsTaken']),
    userTypes () {
      return objectToArray(this.$store.state.userTypes.items)
    },
    usersRouteName () {
      return this.childCompanyUserIsTaken ? 'MyCompanyUsers' : 'Users'
    }
  },
  methods: {
    ...mapActions('users', ['saveItem']),
    ...mapActions('userTypes', { loadUserTypes: 'loadItems' }),
    save ({ data, repeat = false }) {
      const redirect = repeat ? null : this.usersRouteName
      this.saveItem({ id: this.id, ...data })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          if (redirect) {
            this.$router.push({ name: redirect })
          } else {
            this.$refs.form.clearForm()
          }
        })
    },
    cancel () {
      this.$router.push({ name: this.usersRouteName })
    }
  },
  created () {
    this.loadUserTypes()
      .then(userTypes => {
        this.asyncDataStatus_fetched()
      })
  }
}
</script>
